import { FC } from 'react';
import { ReactComponent as RwLogo } from '../../../../assets/logo-rw-small.svg';

import {
  BenefitsHeading,
  BenefitsList,
  ContentCard,
  EnrollButton,
  Heading,
  Heading2,
  InfoText,
  LeftPanel,
  LogoContainer,
  LogoText,
  PageContainer,
  RightPanel
} from './payments-get-started.styles';

const ENROLL_URL =
  'https://www.rectanglehealth.com/revenuewell-client-enrollment?RwAccountId=21054&RwAccountSecret=0011R000024ojNDQAY';

const DEMO_URL = 'https://www2.rectanglehealth.com/revenuewell-healthcare-technology-solution/';

const WHY_PAYMENTS_URL = 'https://help.revenuewell.com/hc/en-us/articles/25556171555099-Payments-Rectangle-Health';

export const PaymentsGetStarted: FC = () => {
  return (
    <PageContainer>
      <ContentCard>
        <LeftPanel>
          <Heading variant="subtitle1">
            To get started with RevenueWell Payments, you will first need to set up your merchant account with our
            payments provider, Rectangle Health
          </Heading>
          <EnrollButton onClick={() => window.open(ENROLL_URL, '_blank', 'noopener,noreferrer')}>
            Enroll Rectangle Health Account
          </EnrollButton>
          <Heading2 variant="subtitle1">Not ready to enroll?</Heading2>
          <EnrollButton onClick={() => window.open(DEMO_URL, '_blank', 'noopener,noreferrer')}>
            Request a Rectangle Health Demo
          </EnrollButton>
          <LogoContainer>
            <RwLogo width={36} height={36} />
            <LogoText>payments</LogoText>
          </LogoContainer>
        </LeftPanel>
        <RightPanel>
          <InfoText variant="body2">
            RevenueWell Payments gives your patients a simple and secure way to pay their outstanding balances, and your
            practice the ability to view transactions in real-time.
          </InfoText>
          <BenefitsHeading variant="subtitle2">Other benefits include:</BenefitsHeading>
          <BenefitsList>
            <li>A simple, practice-specific link to use anywhere to collect payments from patients</li>
            <li>Flexibility to collect payments online and/or at your physical practice location</li>
            <li>Competitive industry transaction fees through our partner, Rectangle Health</li>
            <li>No extra monthly, set-up, or network fees</li>
            <li>Real-time alerts when payments are received</li>
          </BenefitsList>
          <InfoText variant="body2" sx={{ fontWeight: 'normal' }}>
            For more information visit:{' '}
            <a href={WHY_PAYMENTS_URL} target="_blank" rel="noreferrer">
              Why RevenueWell Payments
            </a>
          </InfoText>
        </RightPanel>
      </ContentCard>
    </PageContainer>
  );
};
